import { usePreviewStateFull } from "react-dnd-preview/dist/usePreview";
import { EDragDropObject } from "source/app/services/Shared/EDragDropObject";
import { CalendarEvent } from "../MainPanel/Calendar/CalendarEventUtils/CalendarEvent";
import IDream from "motw_core/Entity/IDream";
import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";

export function GetPreviewToDisplay(
    preview: usePreviewStateFull<unknown, Element>
) {
    const { itemType } = preview;

    if (itemType === EDragDropObject[EDragDropObject.calendarEvent]) {
        return (preview.item as CalendarEvent).eventData.name;
    }

    if (
        itemType === EDragDropObject[EDragDropObject.dreamRow] ||
        itemType === EDragDropObject[EDragDropObject.dreamRow_fromChessBoard]
    ) {
        return (preview.item as IDream).name;
    }

    if (itemType === EDragDropObject[EDragDropObject.workflowNode]) {
        return (preview.item as IWorkflowNode).name;
    }

    return preview.itemType;
}
